import React from 'react';

import RescheduleClassRow from '../RescheduleClassRow';
import styles from './RescheduleClassesTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function RescheduleClassesTable({ sbatGroups }) {
  return (
    <Table>
      <TableHead className={styles.head}>
        <TableRow>
          <TableCell className={styles.title}>Title</TableCell>
          <TableCell className={styles.batches}>Batches</TableCell>
          <TableCell className={styles.instructor}>
            Primary, Secondary Instructor
          </TableCell>
          <TableCell className={styles.module}>Module Name</TableCell>
          <TableCell className={styles.schedule}>Current Schedule</TableCell>
          <TableCell className={styles.lock}>Lock Lecture</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sbatGroups.map((sbatGroup) => (
          <RescheduleClassRow
            key={sbatGroup.id}
            sbatGroup={sbatGroup}
          />
        ))}
      </TableBody>
    </Table>
  );
}

export default RescheduleClassesTable;
